// pages/FormViewerPage/sections/orderSummary/shippingLabel.tsx — Label ongkir (gratis/subsidi/bayar)
import React from 'react';
import { formatMoney } from '../../../../utils/formatMoney';
import { getEffectiveMaxSubsidy } from '../../../../utils/shippingSubsidy';
import { ms } from '../../../../locales/ms';

export type ShippingLabelState = 'paid' | 'gratis-subsidi' | 'gratis' | 'pending' | 'not-included';

// Murni (testable): subsidi + ongkir 0 + tarif BELUM ketemu = 'pending'
// (jangan tulis GRATIS — ambigu, rawan misskom ke customer).
export function getShippingLabelState(form: any, shippingCost: number, selectedEverproRate: any, currentCombination?: { maxSubsidy?: number | null; attributes?: Record<string, string> } | string | null, quantity?: number | null): ShippingLabelState {
    const isGratisLike = !!(form.shippingSettings?.free?.visible) && !form.shippingSettings?.regular?.visible;
    const maxSubsidy = isGratisLike ? getEffectiveMaxSubsidy(form, currentCombination ?? null, quantity ?? 1) : 0;
    const isSubsidi = maxSubsidy > 0;
    if (shippingCost > 0) return 'paid';
    if (!isGratisLike) return 'not-included';
    if (!isSubsidi) return 'gratis';
    const hasRate = (Number(selectedEverproRate?.price) || 0) > 0;
    return hasRate ? 'gratis-subsidi' : 'pending';
}

export function computeShippingLabel(form: any, shippingCost: number, selectedEverproRate: any, currentCombination?: { maxSubsidy?: number | null; attributes?: Record<string, string> } | string | null, quantity?: number | null): { shippingLabel: React.ReactNode; isSimpleBayar: boolean } {
    const rp = (n: number) => formatMoney(n, form);
    const isGratisLike = !!(form.shippingSettings?.free?.visible) && !form.shippingSettings?.regular?.visible;
    const maxSubsidy = isGratisLike ? getEffectiveMaxSubsidy(form, currentCombination ?? null, quantity ?? 1) : 0;
    const isSubsidi = maxSubsidy > 0;
    const isGratis = isGratisLike && !isSubsidi;
    const fullRate = Number(selectedEverproRate?.price) || 0;
    const subsidyUsed = isSubsidi && fullRate > 0 ? Math.min(fullRate, Math.round(maxSubsidy)) : 0;
    const isSimpleBayar = (form.addressInputMode === 'none' || form.addressInputMode === 'simple') && !form.javaOnly && !isGratisLike;

    const isMY = (form as any)?.addressCountry === 'MY';
    const state = getShippingLabelState(form, shippingCost, selectedEverproRate, currentCombination ?? null, quantity ?? 1);
    const shippingLabel = state === 'paid'
        ? (subsidyUsed > 0
            ? <span>{rp(shippingCost)} <span className="text-xs font-normal text-emerald-600 dark:text-emerald-400">({isMY ? 'jimat' : 'hemat'} {rp(subsidyUsed)})</span></span>
            : rp(shippingCost))
        : state === 'gratis-subsidi'
            ? <span className="text-emerald-600 dark:text-emerald-400">{isMY ? 'PERCUMA' : 'GRATIS'} <span className="text-xs font-normal">(subsidi {rp(subsidyUsed)})</span></span>
            : state === 'gratis'
                ? <span className="text-emerald-600 dark:text-emerald-400">{isMY ? ms(form, m => m.freeShipping, 'PERCUMA').toUpperCase() : 'GRATIS'}</span>
                : state === 'pending'
                    ? <span className="text-slate-500 dark:text-slate-400">Ongkir belum dihitung</span>
                    : <span className="text-amber-600 dark:text-amber-400">{ms(form, m => m.notIncluded, 'Belum termasuk')}</span>;

    return { shippingLabel, isSimpleBayar };
}
